import $ from 'jquery';

$.addInit(function(context){
	var base = '.b-achievementList';
	$(base, context).each(function(i, el) {
		var $el = $(el);

		var containerWidth = 0;
		var originalSpeed = $el.data('speed') || 1;
		var speed = originalSpeed;

		var achievementMove;
		var achievementMoveChildren;
		var achievementMoveWidth;
		var achievementAnimation;

		function restoreDuration() {
			achievementAnimation.playbackRate = Math.abs(speed);
		}

		function wrap() {
			var itemHtml = $el[0].innerHTML;

			$el[0].innerHTML =
				'<div class="b-achievementList-container">' +
					'<div class="b-achievementList-inner">' +
						itemHtml +
					'</div>' +
					'<div class="b-achievementList-inner">' +
						itemHtml +
					'</div>' +
				'</div>';
		}

		function init() {
			var groupTracks = $el.find('.b-achievementList-inner');
			containerWidth = groupTracks[0].getBoundingClientRect().width;

			achievementMove = $el.find('.b-achievementList-container');
			achievementMoveChildren = achievementMove.find('.b-achievementList-item');
			achievementMoveWidth = achievementMove[0].getBoundingClientRect().width;

			achievementAnimation = achievementMove[0].getAnimations()[0];
		}

		wrap();
		init();
		restoreDuration();
	});
});
